import { Component, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";

import { ApiResponse } from "src/app/shared/interfaces/api-response";
import { ReportListItems } from "src/app/shared/interfaces/reports";
import { StrikeDetail } from "src/app/shared/interfaces/strike-details";
import { StrikeHouses, StrikeHouse } from "src/app/shared/interfaces/strike-houses";
import { StrikePicketLines } from "src/app/shared/interfaces/strike-picketlines";
import { StrikeShifts } from "src/app/shared/interfaces/strike-shifts";
import { WalkSummary } from "src/app/shared/interfaces/walk-summary";
import { WeekSummary } from "src/app/shared/interfaces/week-summary";
import { ModalService } from "../../core/modal.service";
import { NotificationService } from "../../core/notification.service";
import { StrikeService } from "../../core/strike.service";
import { AddHouseModalComponent } from "../modals/add-house-modal/add-house-modal.component";
import { AddPicketlineModalComponent } from "../modals/add-picketline-modal/add-picketline-modal.component";
import { AddShiftModalComponent } from "../modals/add-shift-modal/add-shift-modal.component";
import { Report, Reports } from 'src/app/shared/interfaces/report';
import { ReportsModalComponent } from '../modals/reports/reports.component';
@Component({
  selector: "app-strike-details",
  templateUrl: "./strike-details.component.html",
  styleUrls: ["./strike-details.component.css"]
})

export class StrikeDetailsComponent implements OnInit, OnDestroy {
  public subscription: Subscription = new Subscription;
  paramId: string | number = "";
  strike: StrikeDetail = {
    weekNumber: 0,
    dayNumber: 0,
  };
  strikeHouses: StrikeHouses = [];
  strikePicketlines: StrikePicketLines = [];
  strikeShifts: StrikeShifts = [];
  walkSummary: WalkSummary = [];
  weekSummary: WeekSummary = [];

  reports: Reports = [
    { repName: "MbrSummary", repDescr: "Member Weekly Summary", repParams: [ { "name": "format", "label": "Format:", "type": "select", "subtype": "radio", "options": ["excel", "pdf"] }, { "name": "weekno", "label": "Week Number:", "type": "text", "subtype": "number-input" }], repCtrlName: "mbrsummaryparamCtrl", repEndPoint: "api/reports/MbrSummary",   }
    , { repName: "NoWalk", repDescr: "No Walk Report", repParams: [], repCtrlName: "nowalkparamCtrl", repEndPoint: "api/reports/NoWalk",   }
    , { repName: "NoWalkByWeek", repDescr: "No Walk Report By Week", repParams: [ { "name": "format", "label": "Format:", "type": "select", "subtype": "radio", "options": ["excel", "pdf"] }, { "name": "weekno", "label": "Week Number:", "type": "text", "subtype": "number-input" }], repCtrlName: "nowalkbyweekparamCtrl", repEndPoint: "api/reports/NoWalkByWeek",   }
    , { repName: "WeeklySignIn", repDescr: "Weekly Picketline Sign-in", repParams: [ {"name": "weekno", "label": "Week Number:", "type": "text", "subtype": "number-input"}, {"name": "dayno", "label": "Day Number:", "type": "text", "subtype": "number-input"}, {"name": "housename", "label": "House:", "type": "select", "options": [], "subtype": "dropdown"}, {"name": "startdate", "label":"Start date:", "type": "date"} ], repCtrlName: "weeklysigninparamCtrl", repEndPoint: "api/reports/WeeklySignIn",   }
    , { repName: "SignIn", repDescr: "Sign In Sheet - Contract Ratification", repParams: [ {"name": "housename", "label": "House:", "type": "select", "options": [], "subtype": "dropdown"} ], repCtrlName: "signinparamCtrl", repEndPoint: "api/reports/SignIn",   }
    , { repName: "WalkReport", repDescr: "Walk Report", repParams: [{ "name": "reportformat", "label": "Format:", "type": "select", "subtype": "radio", "options": ["excel", "pdf"] }, {"name": "reportmode", "label": "Report Mode:", "type": "select", "options": ['SUMMARY', 'DETAIL' ], "subtype": "dropdown"}, {"name": "fromDate", "label":"Start Date:", "type": "date"}, {"name": "toDate", "label":"End Date:", "type": "date"}  ], repCtrlName: "walkreportparamCtrl", repEndPoint: "api/reports/WalkReport",   }
    , { repName: "WalkReportByLocation", repDescr: "Walk Report By Location", repParams: [{ "name": "reportformat", "label": "Format:", "type": "select", "subtype": "radio", "options": ["excel", "pdf"] }, {"name": "reportmode", "label": "Report Mode:", "type": "select", "options": ['SUMMARY', 'DETAIL' ], "subtype": "dropdown"}, {"name": "fromDate", "label":"Start Date:", "type": "date"}, {"name": "toDate", "label":"End Date:", "type": "date"}  ], repCtrlName: "walkreportbylocationparamCtrl", repEndPoint: "api/reports/WalkReportByLocation",   }
    , { repName: "MbrPayAnalysis", repDescr: "Member Pay Analysis", repParams: [{"name": "fromDate", "label":"From Date:", "type": "date"}], repCtrlName: "mbrpayanalysisparamCtrl", repEndPoint: "api/reports/MbrPayAnalysis",   }
    , { repName: "MbrEligibility", repDescr: "Member Eligibility for Pay", repParams: [{ "name": "format", "label": "Format:", "type": "select", "subtype": "radio", "options": ["excel", "pdf"] }, { "name": "includeDOB", "label": "Include Birth Year:", "type": "select", "subtype": "checkbox", "options": [ "Include Birth Year", ] }, { "name": "includeMbrId", "label": "Include Member ID:", "type": "select", "subtype": "checkbox", "options": ["Include Member ID"] }, {"name": "fromDate", "label":"From Date:", "type": "date"} ], repCtrlName: "mbreligibilityparamCtrl", repEndPoint:"api/reports/MbrEligibility",   }
    , { repName: "MbrWalkSummary", repDescr: "Member Walk Summary Report", repParams: [], repCtrlName: "", repEndPoint: "api/reports/MbrWalkSummary",   }
    , { repName: "StrikeSummary", repDescr: "Strike Summary by Week Report", repParams: [], repCtrlName: "", repEndPoint: "api/reports/StrikeSummary",   }
    , { repName: "DbCardIssued", repDescr: "Debit Cards Issued Report", repParams: [], repCtrlName: "", repEndPoint: "api/reports/DbCardIssued",   }
    , { repName: "HelperEligMissing", repDescr: "Helper Eligibility Missing Report", repParams: [{"name": "fromDate", "label":"From Date:", "type": "date"}], repCtrlName: "HelperEligMissingParamCtrl", repEndPoint: "api/reports/MissingHelperEligMbr",   }
    , { repName: "MissingSignOut", repDescr: "Missing Sign-Out Member Report", repParams: [ { "name": "reportformat", "label": "Format:", "type": "select", "subtype": "radio", "options": ["excel", "pdf"] }, {"name": "fromDate", "label":"Start Date:", "type": "date"}, {"name": "toDate", "label":"End Date:", "type": "date"} ], repCtrlName: "MissingSignOutParamCtrl", repEndPoint: "api/reports/MissingSignOut",   }
    , { repName: "MemberInfo", repDescr: "All Member Info Report", repParams: [], repCtrlName: "", repEndPoint: "api/reports/MemberInfo",   }
    , { repName: "MemberExport", repDescr: "Incremental Member Export", repParams: [], repCtrlName: "",  repEndPoint: "api/reports/MemberExport",  }
    , { repName: "MbrMultipleWalksReport", repDescr: "Multiple Walk Report", repParams: [ {"name": "fromDate", "label":"Start Date:", "type": "date"}, {"name": "toDate", "label":"End Date:", "type": "date"} ], repCtrlName: "MbrMultipleWalksReportParamCtrl", repEndPoint: "api/reports/MbrMultipleWalksReport",   }
    , { repName: "Label5390Report", repDescr: "Name Tags - Avery 5390", repParams: [ {"name": "housename", "label": "House:", "type": "select", "options": [], "subtype": "dropdown"} ], repCtrlName: "Label5390ReportParamCtrl", repEndPoint: "api/reports/Label5390",   }
    , { repName: "Label5160Report", repDescr: "Name Tags - Avery 5160", repParams: [ {"name": "housename", "label": "House:", "type": "select", "options": [], "subtype": "dropdown"} ], repCtrlName: "Label5160ReportParamCtrl", repEndPoint: "api/reports/Label5390",   }
    , { repName: "Label5390ReportNoFilter", repDescr: "Name Tags - Avery 5390 No Filter", repParams: [], repCtrlName: "Label5390ReportAllCtrl", repEndPoint: "api/reports/Label5390ReportAll",   }
    , { repName: "MbrDemographicsInfoAll", repDescr: "All Member Info Report No Filter", repParams: [], repCtrlName: "MbrDemographicsInfoAllAllCtrl", repEndPoint: "api/reports/MbrDemographicsInfoAll",   }
    , { repName: "MbrDemographicsInfo", repDescr: "Member Demographics Report", repParams: [{"name": "housename", "label": "House:", "type": "select", "options": [], "subtype": "dropdown"}], repCtrlName: "MbrDemographicsInfoReportParamCtrl", repEndPoint:"api/reports/MbrDemographics"}
  ];

  reportsLeft: any = [];
  reportsRight: any = [];

  constructor(
    private strikes: StrikeService,
    private route: ActivatedRoute,
    private modal: ModalService,
    private notificationService: NotificationService,
  ) { }

  async loadComponents(paramId: string) {
    this.loadStrike(paramId);
    this.loadStrikeHouses(paramId);
    this.loadStrikePicketlines(paramId);
    this.loadStrikeShifts(paramId);
    this.loadWalkSummary(paramId);
    this.loadWeekSummary(paramId);
  }

  ngOnInit() {
    this.paramId = this.route.snapshot.paramMap.get('id') || '';
    if (this.paramId) {
      this.loadComponents(this.paramId);
    }
    this.splitReports(this.reports);
  }

  async loadStrike(paramId: string | number) {
    const strikeDetails: StrikeDetail = await this.strikes.getStrikeDetails(paramId);
    // strikeDetails is (potentially empty) object {}
    if (Object.keys(strikeDetails).length) {
      this.strike = strikeDetails;
    }
    else {
      this.notificationService.displayError('Error loading strike');
    }
  }

  async loadStrikeHouses(paramId: string | number) {
    const strikeHouses: StrikeHouses = await this.strikes.getStrikeHouses(paramId);
  
    // strikeHouses is always a list (possibly empty)
    if (strikeHouses.length) {
      this.strikeHouses = strikeHouses;
  
      // Update repParams options for reports with matching housename
      this.reports.forEach((report: { repParams: Report["repParams"]; }) => {
        if (report.repParams && report.repParams.length && report.repParams.some(param => param.name === "housename")) {
          const housenameParam = report.repParams.find(param => param.name === "housename");
          if (housenameParam) {
            housenameParam.options = this.strikeHouses;
          }
        }
      });
    } else {
      this.notificationService.displayError('No strike houses found');
    }
  }

  async loadStrikePicketlines(paramId: string | number) {
    const picketLines: StrikePicketLines = await this.strikes.getStrikePicketlines(paramId);
    // picketLines is always list (possibly empty)
    if (picketLines.length) {
      this.strikePicketlines = picketLines;
    }
    else {
      this.notificationService.displayError('No picket lines found');
    }
  }

  async loadStrikeShifts(paramId: string | number) {
    const strikeShifts: StrikeShifts = await this.strikes.getStrikeShifts(paramId);
    // strikeShifts is always list (possibly empty)type
    if (strikeShifts.length) {
      this.strikeShifts = strikeShifts;
    }
    else {
      this.notificationService.displayError('No strike shifts found');
    }
  }

  async loadWalkSummary(paramId: string | number) {
    const walkSummaryItems: WalkSummary = await this.strikes.getWalkSummary(paramId);
    // walkSummaryItems is always list (possibly empty)
    if (walkSummaryItems.length) {
      this.walkSummary = walkSummaryItems;
    }
    else {
      this.notificationService.displayError('No walk summary items found');
    }
  }

  async loadWeekSummary(paramId: string | number)  {
    const weekSummaryItems: WeekSummary = await this.strikes.getWeekSummary(paramId);
    // weekSummaryItems is always list (possibly empty)
    if (weekSummaryItems.length) {
      this.weekSummary = weekSummaryItems;
    }
    else {
      this.notificationService.displayError('No week summary items found');
    }
  }

  splitReports(reports: any) {
    for (let i = 0; i < reports.length; i++) {
        i % 2 == 0 ? this.reportsLeft.push(reports[i]) : this.reportsRight.push(reports[i])
    }
  }

  openAddHouseModal() {
    const state = {
      strike: this.strike
    }

    this.modal.openModal(AddHouseModalComponent, state)

    this.subscription = this.modal.submitClicked.asObservable().subscribe((clicked: boolean) => {
      if (clicked) {
        this.loadStrikeHouses(this.paramId).then(() => {
          this.modal.submitClicked.next(false)
        })
      }
      this.subscription.unsubscribe()
    })
  }

  openAddShiftModal() {
    const state = {
      strike: this.strike
    }

    this.modal.openModal(AddShiftModalComponent, state);

    this.subscription = this.modal.submitClicked.asObservable().subscribe((clicked: boolean) => {
      if (clicked) {
        this.loadStrikeShifts(this.paramId).then((response) => {
          this.modal.submitClicked.next(false )
        })
      }
      this.subscription.unsubscribe()
    })
  }

  openAddPicketlineModal() {
    const state = {
      strike: this.strike
    }

    this.modal.openModal(AddPicketlineModalComponent, state);

    this.subscription = this.modal.submitClicked.asObservable().subscribe((clicked: boolean) => {
      if (clicked) {
        this.loadStrikePicketlines(this.paramId).then(() => {
          this.modal.submitClicked.next(false)
        })
      }
      this.subscription.unsubscribe()
    })
  }

  async refreshData(house: StrikeHouse) {
    const response: ApiResponse = await this.strikes.refreshData(house);

    if (response.success) {
      this.notificationService.displaySuccess("House employees data refreshed!");
    } else {
      this.notificationService.displayError(response.errorMessage);
    }
  }

  openReportsModal(report: Report) {
    const state = {
      title: report.repDescr,
      strikeID: this.paramId,
      strikeName: this.strike.Title,
      repParams: report.repParams,
      reportEndPoint: report.repEndPoint,
    };

    this.modal.openModal(ReportsModalComponent, state);
  }
  
  

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
